export enum FLAG_TYPE {
  STRING = 'string',
  BOOLEAN = 'boolean',
  JSON = 'json',
  NUMBER = 'number',
}

export interface FeatureFlagConfig {
  [key: string]: {
    id: FEATURE_FLAGS;
    type: FLAG_TYPE.BOOLEAN | FLAG_TYPE.JSON | FLAG_TYPE.STRING | FLAG_TYPE.NUMBER;
  };
}

export enum FEATURE_FLAGS {
  PHOENIX_CORE_TEST_FLAG = 'phoenix_core_test_flag',
  PHOENIX_CORE_TEST_STRING = 'phoenix_core_test_string',
  PHOENIX_CORE_TEST_JSON = 'phoenix_core_test_json',
  EXPERIENCE_MCOM_BRAND_CSS = 'experience_mcom_brand_css',
  EXPERIENCE_MCOM_DTT_GROUP = 'experience_mcom_dtt_group',
  EXPERIENCE_MCOM_DTT_GROUP_UXL_ALLOW_DEFAULT_DATES = 'experience_mcom_dtt_group_uxl_allow_default_dates',
  EXPERIENCE_EXPMGMT_BOOK_DTT = 'experience_sandbox_book_dtt',
  EXPERIENCE_MCOM_BOOK_DTT_PROPERTIES_TYPE = 'experience_mcom_book_dtt_properties',
  EXPERIENCE_MCOM_MGP_BOOK = 'experience_mcom_mgp_book',
  EXPERIENCE_MCOM_MGP_BOOK_NRP = 'experience_mcom_book_dtt_book_nrp',
  EXPERIENCE_MCOM_DTT_BOOK_MASTER_FLAG = 'experience_mcom_book_dtt_master_flag',
  EXPERIENCE_MCOM_LOGO_AUTOMATION = 'experience_mcom_logo_automation',
  CNEXPERIENCE_CNMCOM_CBDT = 'cnexperience_cnmcom_cbdt',
  EXPERIENCE_MCOM_BOOK_BAU_RLM = 'experience_mcom_book_bau_rlm',
  EXPERIENCE_MCOM_BOOK_BAU_REMOTESPA_LOCALES = 'experience_mcom_book_bau_remotespa_locales',
  EXPERIENCE_MCOM_RTP_ENABLE_ACDL = 'experience_mcom_rtp_enable_acdl',
  EXPERIENCE_MCOM_MBOP = 'experience_mcom_mbop',
  EXPERIENCE_MCOM_REPORTING_SCHEDULER = 'experience_mcom_reporting_scheduler_enabled',
  EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS = 'experience_mcom_carousel_lightining_variants',
  EXPERIENCE_MCOM_ACCOUNT_HIDE_FOR_LOCALES = 'experience_mcom_account_hide_for_locales',
  EXPERIENCE_MCOM_ACCOUNT_GIFT_CARD_LENGTH = 'experience_mcom_account_gift_card_length',
  EXPERIENCE_MCOM_ACCOUNT_FORGOT_PASSWORD_REDIRECTION = 'experience_mcom_account_forgot_password_redirection',
  EXPERIENCE_MCOM_BOOK_DTT_ENABLE_NEW_RLM = 'experience_mcom_book_dtt_enable_new_rlm',
  EXPERIENCE_MCOM_COBRAND_ENABLE_ECM = 'experience_mcom_cobrand_enable_ecm',
  EXPERIENCE_MCOM_COBRAND_ECM_CARD_CONFIG = 'experience_mcom_cobrand_ecm_card_config',
  EXPERIENCE_MCOM_ACCOUNT_SEO_URLS = 'experience_mcom_account_seo_urls',
  EXPERIENCE_MCOM_ACCOUNT_API_MAX_RETRY_LIMIT = 'experience_mcom_account_api_max_retry_limit',
  EXPERIENCE_MCOM_SHOP_ENABLE_SOO = 'experience_mcom_shop_enable_soo',
  EXPERIENCE_MCOM_ACCOUNT_CHECK_IN_ELIGIBLE_DOMAINS = 'experience_mcom_account_check_in_eligible_domains',
  EXPERIENCE_MCOM_BOOK_DTT_CRS_INVENTORY_NAME = 'experience_mcom_book_dtt_crs_inventory_name',
  EXPERIENCE_MCOM_SHOP_ADF_ZUSTAND = 'experience_mcom_shop_adf_zustand',
  EXPERIENCE_MCOM_BOOK_DTT_ENABLE_ACRS_FILTERS = 'experience_mcom_book_dtt_enable_acrs_filters',
  EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER = 'experience_mcom_book_bau_required_phone_number',
  EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER_AUTH = 'experience_mcom_book_bau_required_phone_number_auth',
}

export const featureFlagDefinitions: FeatureFlagConfig = {
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_CRS_INVENTORY_NAME]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_CRS_INVENTORY_NAME,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_ENABLE_NEW_RLM]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_ENABLE_NEW_RLM,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.PHOENIX_CORE_TEST_FLAG]: {
    id: FEATURE_FLAGS.PHOENIX_CORE_TEST_FLAG,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.PHOENIX_CORE_TEST_STRING]: {
    id: FEATURE_FLAGS.PHOENIX_CORE_TEST_STRING,
    type: FLAG_TYPE.STRING,
  },
  [FEATURE_FLAGS.PHOENIX_CORE_TEST_JSON]: {
    id: FEATURE_FLAGS.PHOENIX_CORE_TEST_JSON,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BRAND_CSS]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BRAND_CSS,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP_UXL_ALLOW_DEFAULT_DATES]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP_UXL_ALLOW_DEFAULT_DATES,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_EXPMGMT_BOOK_DTT]: {
    id: FEATURE_FLAGS.EXPERIENCE_EXPMGMT_BOOK_DTT,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_PROPERTIES_TYPE]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_PROPERTIES_TYPE,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_MGP_BOOK]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_MGP_BOOK,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_MGP_BOOK_NRP]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_MGP_BOOK_NRP,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_BOOK_MASTER_FLAG]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_BOOK_MASTER_FLAG,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_RLM]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_RLM,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REMOTESPA_LOCALES]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REMOTESPA_LOCALES,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_RTP_ENABLE_ACDL]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_RTP_ENABLE_ACDL,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_MBOP]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_MBOP,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_REPORTING_SCHEDULER]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_REPORTING_SCHEDULER,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_HIDE_FOR_LOCALES]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_HIDE_FOR_LOCALES,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_GIFT_CARD_LENGTH]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_GIFT_CARD_LENGTH,
    type: FLAG_TYPE.STRING,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_FORGOT_PASSWORD_REDIRECTION]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_FORGOT_PASSWORD_REDIRECTION,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_COBRAND_ENABLE_ECM]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_COBRAND_ENABLE_ECM,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_COBRAND_ECM_CARD_CONFIG]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_COBRAND_ECM_CARD_CONFIG,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_SEO_URLS]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_SEO_URLS,
    type: FLAG_TYPE.JSON,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_API_MAX_RETRY_LIMIT]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_API_MAX_RETRY_LIMIT,
    type: FLAG_TYPE.NUMBER,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_ENABLE_SOO]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_ENABLE_SOO,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_CHECK_IN_ELIGIBLE_DOMAINS]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_CHECK_IN_ELIGIBLE_DOMAINS,
    type: FLAG_TYPE.STRING,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER_AUTH]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_BAU_REQUIRED_PHONE_NUMBER_AUTH,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_ADF_ZUSTAND]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_ADF_ZUSTAND,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.CNEXPERIENCE_CNMCOM_CBDT]: {
    id: FEATURE_FLAGS.CNEXPERIENCE_CNMCOM_CBDT,
    type: FLAG_TYPE.BOOLEAN,
  },
  [FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_ENABLE_ACRS_FILTERS]: {
    id: FEATURE_FLAGS.EXPERIENCE_MCOM_BOOK_DTT_ENABLE_ACRS_FILTERS,
    type: FLAG_TYPE.BOOLEAN,
  },
};

export const TARGETS = {
  APP: {
    CONTACTLESS_RENDERER: {
      identifier: 'mi-contactless-renderer',
      name: 'mi-contactless-renderer',
    },
    BOOK_RENDERER: {
      identifier: 'mi_book_renderer_mgp',
      name: 'mi-book-renderer-mgp',
    },
    GROUPS_RENDERER: {
      identifier: 'mi-groups-renderer',
      name: 'mi-groups-renderer',
    },
    ACCOUNT_RENDERER: {
      identifier: 'mi-account-renderer',
      name: 'mi-account-renderer',
    },
    SHOP_RENDERER: {
      identifier: 'mi-shop-renderer',
      name: 'mi-shop-renderer',
    },
    COBRAND_RENDERER: {
      identifier: 'mi-cobrand-renderer',
      name: 'mi-cobrand-renderer',
    },
    LUXURY_RENDERER: {
      identifier: 'mi-luxury-renderer',
      name: 'mi-luxury-renderer',
    },
    OFFERS_RENDERER: {
      identifier: 'mi-offers-renderer',
      name: 'mi-offers-renderer',
    },
    PPV5_RENDERER: {
      identifier: 'mi-ppv5-renderer',
      name: 'mi-ppv5-renderer',
    },
    LEISURE_RENDERER: {
      identifier: 'mi-leisure-renderer',
      name: 'mi-leisure-renderer',
    },
    HOMEPAGE_RENDERER: {
      identifier: 'mi-homepage-renderer',
      name: 'mi-homepage-renderer',
    },
    LANDINGPAGE_RENDERER: {
      identifier: 'mi-landingpage-renderer',
      name: 'mi-landingpage-renderer',
    },
    BRANDS_RENDERER: {
      identifier: 'mi-brands-renderer',
      name: 'mi-brands-renderer',
    },
  },
};
